import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../utils/types";
import { chooseRole } from "../../../redux/auth/actions";

const mapStateToProps = (state: StateType) => ({});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      chooseRole,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
